export class BookingPageModel {
    fromItem: number;
    toItem: number;
    totalItem: number;
    limit: number;
    page: number;
    totalPage: number;
    sortBy: string;
    filterBy: string;
    items: BookingListModel[];
}

export class BookingListModel {
    bookingId: number;
    bookingStatus: string;
    hotelName: string;
    hotelStar: number;
    hotelAddress: string;
    latitude: number;
    longitude: number;
    purpose: string;
    hotelImage: string;
    bookingDate: string;
    payOnDate: string;
    approvalDate: string;
    cancelDate: string;
    checkInDate: string;
    checkOutDate: string;
    reviewSubmitDate?: number;
    reviewToken?: string;
    quantity: number;
    adult: number;
    child: number;
    paymentType: string;
    cancelBy: string;
    cancelName: string;
}

export class DisplayBookingListDTO {
    productTitle: string;
    address: string;
    dateOrder: string;
    timeOrder: string;
    payOnDate: string;
    cancellationDate: string;
    approvalDate: string;
    dayCheckin: string;
    dateCheckin: string;
    monthYearCheckin: string;
    longDateCheckin: string;
    dayCheckout: string;
    dateCheckout: string;
    monthYearCheckout: string;
    longDateCheckout: string;
    ratingStar: number[];
    isReviewPublished: boolean;
    reviewUrl?: string;
    totalRoom: number;
    totalAdult: number;
    totalChild: number;
}

export class BookingApprovalModel {
    approvalDate: string;
    approvalStatus: string;
    reporterEmail: string;
    reporterName: string;
    updateBy: string;
}



// WEBPACK FOOTER //
// ./src/app/model/booking/booking-list.model.ts